import { render, staticRenderFns } from "./RecordSummaryCard.vue?vue&type=template&id=51907b5c&scoped=true&"
import script from "./RecordSummaryCard.vue?vue&type=script&lang=ts&"
export * from "./RecordSummaryCard.vue?vue&type=script&lang=ts&"
import style0 from "./RecordSummaryCard.vue?vue&type=style&index=0&id=51907b5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51907b5c",
  null
  
)

export default component.exports